var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInteraction = function SvgInteraction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 20 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F4651",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19 12.053v.173m0 0c0-.874-.643-1.62-1.52-1.765l-1.207-.198v.895M19 12.226v2.213c0 1.944 0 2.916-.301 3.69a4.5 4.5 0 0 1-2.606 2.574c-.784.297-1.77.297-3.739.297-1.033 0-1.55 0-2.03-.104a4.55 4.55 0 0 1-1.984-.98c-.373-.317-.683-.725-1.302-1.54L4.307 14.78a1.5 1.5 0 0 1 .029-1.854 1.547 1.547 0 0 1 2.282-.125L8 14.256V5.5a1.5 1.5 0 1 1 3 0v2.974m0 0h.727c1.004 0 1.819.8 1.819 1.79M11 8.473v2.684m2.546-.895v.895m0-.895v-.895h.909c1.004 0 1.818.802 1.818 1.79m0 0v.895"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F4651",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5 7h-.824C2.68 7 1.93 7 1.466 6.56 1 6.122 1 5.415 1 4s0-2.121.465-2.56S2.68 1 4.176 1h11.647c1.498 0 2.247 0 2.712.44C19 1.878 19 2.585 19 4s0 2.121-.465 2.56S17.32 7 15.823 7H14.5"
  })));
};
export default SvgInteraction;